<template>
  <permission-gate
    moduleKey="usuarios"
    :showNoEditAlert="true"
  >
    <template #default="{ canEdit }">
      <main-breadcrumb
        :items="items"
        showBackButton
      ></main-breadcrumb>
      <main-buttons-bar :align="'space-between'">
        <template #left>
          <custom-title>Edición de usuario</custom-title>
        </template>
      </main-buttons-bar>
      <detail-container>
        <el-form
          ref="formRef"
          :model="user"
          :rules="formRules"
          size="default"
        >
          <el-row :gutter="24">
            <custom-data
              :label="'Código'"
              :spanColumn="3"
              :data="user.Codigo"
              style="margin-bottom: 5px"
            ></custom-data>
            <custom-data
              :label="'Fecha creacion'"
              :spanColumn="4"
              :data="user.FechaCreacion ? getDate('dd/mm/yyyy', user.FechaCreacion) : ''"
            ></custom-data>
          </el-row>
          <el-row :gutter="24">
            <el-form-item
              prop="Usuario"
              class="full-width"
            >
              <custom-input
                v-model.number="user.Usuario"
                :label="'Usuario'"
                :settings="{
                  placeholder: 'Ingresar usuario',
                }"
              ></custom-input>
            </el-form-item>
            <el-form-item
              prop="Nombre"
              class="full-width"
            >
              <custom-input
                v-model.number="user.Nombre"
                :label="'Nombre'"
                :settings="{
                  placeholder: 'Ingresar nombre',
                }"
              ></custom-input>
            </el-form-item>
            <el-form-item
              prop="Apellido"
              class="full-width"
            >
              <custom-input
                v-model.number="user.Apellido"
                :label="'Apellido'"
                :settings="{
                  placeholder: 'Ingresar apellido',
                }"
              ></custom-input>
            </el-form-item>
            <el-col :span="4">
              <div class="custom-label">Activo</div>
              <el-switch
                v-model="user.Activo"
                active-text="Si"
                inactive-text="No"
                class="mb-2"
                sieze="large"
              />
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-form-item
              prop="Email"
              class="full-width"
            >
              <custom-input
                v-model="user.Email"
                :label="'Email'"
                :settings="{
                  placeholder: 'Ingresar email',
                }"
              ></custom-input>
            </el-form-item>
            <el-form-item
              prop="TelefonoCelular"
              class="full-width"
            >
              <custom-input
                v-model="user.TelefonoCelular"
                :label="'Celular'"
                :settings="{
                  placeholder: 'Ingresar celular',
                }"
              ></custom-input>
            </el-form-item>
            <el-form-item
              prop="TelefonoLinea"
              class="full-width"
            >
              <custom-input
                v-model="user.TelefonoLinea"
                :label="'Tel. Línea'"
                :settings="{
                  placeholder: 'Ingresar teléfono de línea',
                }"
              ></custom-input>
            </el-form-item>
            <el-form-item
              prop="Interno"
              class="full-width"
            >
              <custom-input
                v-model="user.Interno"
                :label="'Interno'"
                :settings="{
                  placeholder: 'Ingresar interno',
                }"
              ></custom-input>
            </el-form-item>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <div
                class="custom-label"
                style="margin-bottom: 10px"
              >
                Roles
              </div>
              <el-checkbox-group v-model="selectedRoleIds">
                <el-row :gutter="20">
                  <el-col
                    v-for="(column, colIndex) in roleColumns"
                    :key="'col-' + colIndex"
                    :span="6"
                  >
                    <div class="role-column">
                      <el-checkbox
                        v-for="role in column"
                        :key="role.Codigo"
                        :label="role.Codigo"
                        :disabled="isEditingAdmin && role.EsSistema"
                        class="custom-checkbox"
                      >
                        {{ role.Descripcion }}
                      </el-checkbox>
                    </div>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="11">
              <div class="custom-label">Puesto</div>
              <el-checkbox-group v-model="user.PuestoUsuario">
                <el-checkbox
                  v-for="puesto in puestoList"
                  :key="puesto.Codigo"
                  :label="puesto"
                  >{{ puesto.Descripcion }}
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <custom-input-number
              v-model.number="user.Comision"
              :label="'% Comisión'"
              :spanColumn="12"
              :settings="{
                placeholder: '% Comisión',
                min: 0,
                precision: 2,
                step: 0.01,
                controls: false,
              }"
            />
          </el-row>
          <el-divider></el-divider>
          <div style="margin: 40px 20px; text-align: center">
            <div
              class="custom-label"
              style="margin-bottom: 10px"
            >
              Usuarios relacionados
            </div>
            <el-transfer
              v-model="user.UsuariosRelacionados"
              :data="usuariosDisponiblesFiltrados"
              :props="transferProps"
              filterable
              filter-placeholder="Buscar usuario"
            >
            </el-transfer>
          </div>
          <el-row
            v-if="canEdit"
            :gutter="24"
          >
            <el-button
              type="primary"
              size="default"
              :icon="IconPassword"
              @click="openModal"
              >Actualizar contraseña</el-button
            >
            <modal-password-update
              v-model="modalVisible"
              @closed="handleModalClosed"
            ></modal-password-update>
          </el-row>

          <div
            v-if="canEdit"
            class="container"
          >
            <custom-confirm-buttons
              :disabled="false"
              :showLoading="false"
              :confirmText="'Guardar'"
              :cancelText="'Cancelar'"
              @on-cancel="onCancel"
              @on-confirm="onConfirm"
            ></custom-confirm-buttons>
          </div>
        </el-form>
      </detail-container>
    </template>
  </permission-gate>
</template>

<script setup>
import {
  onBeforeMount,
  ref,
  reactive,
  computed,
  watch,
} from 'vue';
import { useUserStore } from './../stores/user_store.js';
import { useRolStore } from '@/stores/rol.js';
import { usePuestoStore } from '@/stores/puesto.js';
import { storeToRefs } from 'pinia';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import CustomData from '@/shared/components/custom_data.vue';
import CustomConfirmButtons from '@/shared/components/custom_confirm_buttons.vue';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import getDate from '@/shared/components/utils.js';
import { ElNotification } from 'element-plus';
import IconPassword from '~icons/mdi/password';
import ModalPasswordUpdate from '../users_list/modal_password_update.vue';
import PermissionGate from '@/shared/components/permission_gate.vue';
const formRef = ref(null);
const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const rolStore = useRolStore();
const puestoStore = usePuestoStore();
const {
  findUserByCodigoHTTP,
  resetUser,
  updateUserHTTP,
  loadUsuariosDisponibles,
  updateUserRolesHTTP,
} = userStore;
const { firstRol } = rolStore;
const { firstPuesto } = puestoStore;
const { user, usuariosDisponibles } = storeToRefs(userStore);
const { rolList } = storeToRefs(rolStore);
const { puestoList } = storeToRefs(puestoStore);
const modalVisible = ref(false);
const formRules = reactive({
  Nombre: [{ required: true, message: 'Ingresar nombre', trigger: 'blur' }],
  Apellido: [{ required: true, message: 'Ingresar apellido', trigger: 'blur' }],
  Usuario: [{ required: true, message: 'Ingresar usuario', trigger: 'blur' }],
  Email: [{ type: 'email', message: 'Ingrese un email válido', trigger: 'blur' }],
});

const selectedRoleIds = ref([]);
const isEditingAdmin = computed(
  () => user.value?.Codigo === 1 || String(user.value?.Usuario || '').toLowerCase() === 'admin',
);

const roleColumns = computed(() => {
  const allRoles = rolList.value || [];

  const col1Names = ['usuarios', 'configuracion', 'prospectos', 'ejecutivo de ventas'];
  const col2Names = ['recursos', 'cilindros', 'suajes', 'materiales'];
  const col3Names = ['solicitud', 'cotizacion', 'propuestas', 'et', 'ot'];

  const getRolesByNames = (names) => {
    return names
      .map((name) => allRoles.find((r) => r.Descripcion?.toLowerCase() === name))
      .filter(Boolean);
  };

  const col1 = getRolesByNames(col1Names);
  const col2 = getRolesByNames(col2Names);
  const col3 = getRolesByNames(col3Names);

  const usedIds = new Set([...col1, ...col2, ...col3].map((r) => r.Codigo));
  const customRoles = allRoles.filter((r) => !usedIds.has(r.Codigo));

  const columns = [col1, col2, col3];

  const chunkSize = 5;
  for (let i = 0; i < customRoles.length; i += chunkSize) {
    columns.push(customRoles.slice(i, i + chunkSize));
  }

  return columns.filter((col) => col.length > 0);
});

watch(
  () => user.value?.Codigo,
  () => {
    selectedRoleIds.value = (user.value.roles || []).map((r) => r.Codigo);
  },
  { immediate: true },
);

const transferProps = {
  key: 'Codigo',
  label: 'Descripcion',
};
const openModal = () => {
  modalVisible.value = true;
};

const handleModalClosed = () => {
  modalVisible.value = false;
};
// local state
const items = [
  { label: 'Inicio', to: '/page/users/list', replace: false },
  { label: 'Edición', to: null, replace: false },
];
const usuariosDisponiblesFiltrados = computed(() => {
  return usuariosDisponibles.value.filter((u) => u.Codigo !== user.value.Codigo);
});

const onConfirm = async () => {
  formRef.value.validate(async (valid) => {
    if (!selectedRoleIds.value.length) {
      ElNotification({
        title: 'Validación',
        message: 'Debe seleccionar al menos un rol.',
        type: 'warning',
      });
      return;
    }
    if (valid) {
      try {
        useLoading().openLoading();
        user.value.Comision = Number(user.value.Comision) || 0;
        const codigo = user.value.Codigo;
        const roleIdsSnapshot = [...selectedRoleIds.value];
        await updateUserHTTP();
        await updateUserRolesHTTP(codigo, roleIdsSnapshot);
        useMessageSuccess().open('Los datos se han actualizado correctamente.');
        router.go(-1);
      } catch (err) {
        useMessageError().open('Ha ocurrido un error al intentar actualizar los datos.');
      } finally {
        useLoading().closeLoading();
      }
    } else {
      ElNotification({
        title: 'Actualizar usuario',
        message: 'Por favor, revise los campos ingresados.',
        type: 'warning',
      });
    }
  });
};

const onCancel = () => {
  resetUser();
  resetFormValidation();
  router.push('/page/users/list');
};

onBeforeMount(() => {
  firstRol();
  firstPuesto();
  if (!usuariosDisponibles.value.length) {
    loadUsuariosDisponibles();
  }
  const id = route.params.id;
  if (id && +id > 0) {
    findUserByCodigoHTTP(id);
  }
});

const resetFormValidation = () => {
  if (formRef.value) {
    formRef.value.resetFields();
  }
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: flex-end; /* Alinea todo el contenido al final del contenedor */
}
.custom-label {
  font-weight: 700;
  color: #111;
}
.button-container {
  margin-top: auto;
  /* Empuja el contenido hacia abajo, ocupando la parte inferior */
}
:deep(.el-transfer-panel) {
  width: 300px;
}
.role-column {
  display: flex;
  flex-direction: column;
  gap: 8px; /* Espacio entre cada checkbox */
}

/* Evitar márgenes raros que a veces trae Element Plus en los checkboxes apilados */
.custom-checkbox {
  margin-right: 0 !important;
  height: auto;
}
</style>
